import React from 'react';
import { useDrawers } from '@hooks/useDrawers';
import { useCurrentOrder } from '@hooks/useCurrentOrder';
import { Stopwatch } from '@commons/stopwatch';
import { useCronometreOrder } from '@hooks/useCronometreOrder';
import dayjs from 'dayjs';
import Loader from '@commons/loader';
import { OrdersDetailsItem } from '@modules/drawers/components/orders-details-item';
import { Button, Divider } from '@nextui-org/react';
import { Icon } from '@iconify/react';

export const OrderInfoDrawer = () => {
  const { data: id, onChangeLoading, loading, onClose } = useDrawers<string>();
  const { data: orderUpdate } = useCurrentOrder(
    { id },
    {
      onSuccess: () => {
        onChangeLoading(false);
      },
    }
  );
  const { getColor, formatElapsedTime, elapsedTime } = useCronometreOrder(orderUpdate, 300);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col px-3 py-5 justify-center items-center gap-5 relative">
      <h5 className="text-small tracking-tight text-center text-default-400 flex flex-col ">
        {orderUpdate?.id}
      </h5>
      <div className="flex flex-row gap-2 items-center w-full justify-start">
        <Stopwatch color={getColor()} timer={formatElapsedTime(elapsedTime)} />
        <div>
          <h2 className="font-bold leading-none text-default-600 text-lg">{orderUpdate?.table}</h2>
          <caption className="text-xs tracking-tight text-default-400 flex flex-row">
            {dayjs(orderUpdate?.createdAt).format('DD/MM/YYYY hh:MM a')}
          </caption>
        </div>
      </div>
      <div className="flex flex-col gap-1 items-start justify-start w-full px-5">
        {orderUpdate?.ordersDetails?.map((orderDetail: any) => (
          <div
            className="flex flex-col gap-2 items-start justify-start w-full"
            key={orderDetail?.id}
          >
            <Divider orientation="vertical" className=" w-full h-[1px]" />
            <OrdersDetailsItem orderDetail={orderDetail} />
          </div>
        ))}
      </div>
    </div>
  );
};
